import SkillCards from './SkillCards'

export default SkillCards
